<template>
    <div class="basic_wrap">
        <div class="red_top_bg">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">{{$t('index.real')}}</div>
        </div>
        <div class="wrap">
            <div class="write_box">
                <input type="text" v-model="name" :readonly="readonly" :placeholder="$t('index.name')">
            </div>
            <div class="write_new_pwd">
                <div class="write_box">
                    <input type="text" v-model="card" :readonly="readonly" :placeholder="$t('index.card')">
                </div>
            </div>
        </div>

        <button v-if="readonly" class="basic_btn" @click="$router.back()">{{$t('返回')}}</button>
        <button v-else class="basic_btn" @click="submit">{{$t('提交')}}</button>
       
    </div>
</template>

<script>
    import Vue from 'vue';
    import {
        CountDown,
    } from 'vant';
    import Fetch from '../../utils/fetch'

    Vue.use(CountDown);

    export default {
        name: "setpwd",
        data() {
            return {
                name: '',
                card: '',
                readonly: false // Initially set to false
            };
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            Fetch('/index/read').then(r => {
                if (r && r.data && (r.data.name || r.data.card)) {
                    this.name = r.data.name;
                    this.card = r.data.card;
                    this.readonly = true; // If data exists, set to readonly
                } else {
                    this.readonly = false; // Otherwise, allow editing
                }
            })
        },
        methods: {
            submit() {
				if (!this.name) {
					this.$toast(this.$t('index.name'));
					return;
				}
				if (!this.card) {
					this.$toast(this.$t('index.card'));
					return;
				}

				// 校验姓名是否只包含汉字、字母和数字
				if (!/^[\u4e00-\u9fa5a-zA-Z0-9]+$/.test(this.name)) {
					this.$toast(this.$t('index.nameerror'));
					return;
				}

				if (!this.card) {
					this.$toast(this.$t('index.carderror'));
					return;
				}

				// 校验证件号是否只包含字母和数字
				if (!/^[a-zA-Z0-9]+$/.test(this.card)) {
					this.$toast(this.$t('index.carderror'));
					return;
				}
                Fetch('/index/read', {
                    name: this.name,
                    card: this.card
                }).then(response => {
                    console.log("Response:", response);
                    if (response && response.code === 1) {
                        // 这样写才是正确的，将 message 赋值给对象的属性
                        this.$toast({
                            background: '#07c160',
                            message: response.msg || this.$t('提交成功') // 或者 this.$t('成功') 等
                        });
                        this.$router.back();
                    } else {
                        this.$toast(response.msg || this.$t('提交失败'));
                    }
                }).catch(error => {
                    console.error("Error submitting data:", error);
                    this.$toast(this.$t('提交失败'));
                });

            },
        }
    };
</script>



<style lang="less" scoped>
	.back_left {
		background: url(../../views/images/item/back_b.png) no-repeat center center;
	}
	.big_tit{
		color: #000000;
	}
	.van-overlay { 
		display: none !important;
	 }
    .no_touch {
        pointer-events: none;
    }

    .wrap {
        padding: 35px 20px 0 20px;
    }

    .title {
        width: 100%;
        height: 25px;
        line-height: 25px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        p {
            font-size: 18px;
            color: #000;
            font-weight: 400;
        }

        .cut {
            font-size: 12px;
            color: #3D96FF;
        }
    }

    .bd_tel {
        margin-top: 23px;
        color: #000;
        font-size: 14px;
        font-weight: 400;
    }

    .inp_box {
        display: flex;
        justify-content: space-between;
        height: 45px;
        margin-top: 9px;

        .inp {
            width: 195px;
            border: 1px solid rgba(0, 0, 0, 0.1);
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 10px;
            border-radius: 2px;
            background-color: #FFFFFF;

            input {
                width: 100%;
                height: 22px;
                line-height: 22px;
                font-size: 16px;
            }
        }

        .getcode {
            flex: 1;
            margin-left: 10px;
            font-size: 16px;
            text-align: center;
            line-height: 45px;
            color: #FFFFFF;
            height: 45px;
            background: linear-gradient(90deg, rgba(228, 57, 46, 1) 0%, rgba(255, 77, 22, 1) 100%);
            border-radius: 8px;
        }

        .reset_code {
            background: rgba(228, 228, 228, 1);
            color: rgba(0, 0, 0, 0.3);
        }
    }

    .write_box {
        width: 100%;
        height: 45px;
        margin-top: 32px;
        background: rgba(255, 255, 255, 1);
        border-radius: 2px;
        border: 1px solid rgba(0, 0, 0, 0.1);
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 10px;
        border-radius: 2px;
        background-color: #FFFFFF;

        input {
            width: 100%;
            height: 22px;
            line-height: 22px;
            font-size: 16px;
        }
    }

    .eye_bi {
        width: 21px;
        height: 25px;
        background: url(../images/user/eye2.png) no-repeat center center;
        background-size: 100% auto;

        &.eye {
            background: url(../images/user/eye1.png) no-repeat center center;
            background-size: 100% auto;
        }
    }

    .basic_btn {
        margin: 43px auto 0 auto;
		display: flex;
    	justify-content: center;
    }

    .write_new_pwd {
        margin-top: 32px;

        .write_box:first-child {
            margin-bottom: 18px;
            margin-top: 0px;
        }

        .write_box:last-child {
            margin-top: 0px;
        }
    }
</style>
